import type { HelpContentOverride } from './types';

/**
 * HypeApp (SAITE) 向けヘルプ文言の上書き
 *
 * 使い方:
 *   上書きしたいキーだけ書く。書かなかったキーは [default.tsx](./default.tsx) の文言が使われる。
 *
 * 例:
 *   export const hypeappHelpContent: HelpContentOverride = {
 *     aspectRatio: (
 *       <>
 *         <p>SAITE では絵コンテ作成モードで縦横比を指定できます...</p>
 *       </>
 *     ),
 *   };
 */
export const hypeappHelpContent: HelpContentOverride = {
  // 現状はデフォルト文言で運用。差し替えが必要になったらここにキーを追加。
};
